import React, { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext({
  isLang: 'En',
  changeLang: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [isLang, setIsLang] = useState(() => localStorage.getItem('lang') || 'En');

  const changeLang = (lang) => {
    setIsLang(lang);
    localStorage.setItem('lang', lang);
  };

  useEffect(() => {
    const storedLang = localStorage.getItem('lang');
    if (storedLang && storedLang !== isLang) {
      setIsLang(storedLang);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ isLang, changeLang }}>
      {children}
    </LanguageContext.Provider>
  );
};